import React from 'react'
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap'
import CardTextData from 'components/molecules/card-text-data'
import PropTypes from 'prop-types'
import PriceUtil from 'utils/price-util'
import CustomerOrderItemStatusBadge from 'domains/customer-order/atoms/item-status-badge'

const propTypes = {
  orderItem: PropTypes.shape({
    sku             : PropTypes.string,
    quantity        : PropTypes.number,
    discount_amount : PropTypes.number,
    price           : PropTypes.number,
    status          : PropTypes.string,
    image           : PropTypes.string,
    name            : PropTypes.string
  })
}

const defaultProps = {
  orderItem: {
    sku             : '',
    quantity        : 0,
    discount_amount : 0,
    price           : 0,
    status          : '',
    image           : '',
    name            : ''
  }
}

const CustomerOrderItemDetailCard        = ({ orderItem }) => (
  <Card>
    <CardHeader>Order Item Detail</CardHeader>
    <CardBody>
      <Row>
        <Col md={ 6 }>
          <CardTextData
            label='SKU'
            value={ orderItem.sku }
          />
          <CardTextData
            label='Name'
            value={ orderItem.name }
          />
          <CardTextData
            label='Quantity'
            value={ orderItem.quantity }
          />
          <CardTextData
            label='Status'
            value={ <CustomerOrderItemStatusBadge status={ orderItem.status } /> }
          />
        </Col>
        <Col md={ 6 }>
          <CardTextData
            label='Price'
            value={ PriceUtil.format(orderItem.price) }
          />
          <CardTextData
            label='Discount Amount'
            value={ PriceUtil.format(orderItem.discount_amount) }
          />
          <CardTextData
            label='Product Image'
            value={ orderItem.image ?
              <img
                src={ orderItem.image }
                width='60%'
              /> : '-'
            }
          />
        </Col>
      </Row>
    </CardBody>

  </Card>
)
CustomerOrderItemDetailCard.propTypes    = propTypes
CustomerOrderItemDetailCard.defaultProps = defaultProps

export default CustomerOrderItemDetailCard
